import React, { ReactNode, createContext, useContext, useState } from 'react';

interface RoleContextType {
  roles: string[];
  setRoles: (roles: string[]) => void;
}

export const RoleContext = createContext<RoleContextType | null>(null);

export const useRoleContext = () => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error('useRoleContext must be used within a RoleProvider');
  }
  return context;
}

export const RoleProvider = ({ children }: { children: ReactNode }) => {
  const [roles, setRoles] = useState([] as string[]);

  return (
    <RoleContext.Provider
      value={{
        roles,
        setRoles,
      }}>
      {children}
    </RoleContext.Provider>
  );
};
